var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdjustFan1Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 16.3333C10.8778 16.4917 11.1237 16.5977 11.3839 16.6425C11.6442 16.6872 11.9114 16.6695 12.1635 16.5908C12.4155 16.512 12.6453 16.3745 12.8338 16.1896C13.0223 16.0046 13.1641 15.7775 13.2476 15.527C13.3312 15.2764 13.3539 15.0096 13.3141 14.7486C13.2743 14.4875 13.173 14.2396 13.0186 14.0254C12.8642 13.8112 12.661 13.6367 12.426 13.5163C12.1909 13.396 11.9306 13.3333 11.6665 13.3333H1.6665",
    stroke: "#525252",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5832 6.66659C14.7962 6.38249 15.0784 6.15758 15.4028 6.0132C15.7273 5.86883 16.0832 5.80978 16.4369 5.84167C16.7906 5.87356 17.1303 5.99533 17.4237 6.19542C17.717 6.3955 17.9544 6.66726 18.1132 6.98489C18.272 7.30252 18.347 7.65547 18.3311 8.01023C18.3151 8.36499 18.2087 8.70978 18.022 9.01186C17.8353 9.31394 17.5745 9.56328 17.2643 9.73621C16.9542 9.90914 16.605 9.99992 16.2498 9.99992H1.6665",
    stroke: "#525252",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1665 3.66659C8.37777 3.50813 8.62367 3.40215 8.88394 3.35738C9.1442 3.31261 9.41138 3.33032 9.66345 3.40906C9.91552 3.4878 10.1453 3.62532 10.3338 3.81028C10.5223 3.99523 10.6641 4.22234 10.7476 4.47287C10.8312 4.72341 10.8539 4.9902 10.8141 5.25127C10.7743 5.51233 10.673 5.7602 10.5186 5.97444C10.3642 6.18867 10.161 6.36315 9.92597 6.48349C9.6909 6.60383 9.43059 6.66659 9.1665 6.66659H1.6665",
    stroke: "#525252",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdjustFan1Icon);
export default __webpack_public_path__ + "static/media/adjust_fan_1_icon.39b399fd6af0ceee856408512d23ec92.svg";
export { ForwardRef as ReactComponent };